export const ListType = {
  ORG: 'org',
  APP: 'app',
  ROLE: 'role',
};

export const AssetListType = {
  MY_ASSETS: 1,
  OFFERED_ASSETS: 2,
  PREV_OWNED_ASSETS: 3,
};

export const enum LoadingCount {
  UP,
  DOWN,
}
